/*
 * Ported verbatim from the legacy app's scripts/app/components/ranking.js.
 */
(function ($) {

    $(function () {

        var body = $('body');
        var html = $('html');
        var ranking = $('.ranking-results');

        if (ranking.length > 0) {


            var navigateToYear = function (year) {
                window.location.search = '?year=' + year;
            };
            body.on('click', '.year-selector',
                function () {
                    var year = $(this).val();
                    console.log('Navigate to year: ' + year);
                    navigateToYear(year);
                });
            $('select').change(function () {
                var year = $(this).children('option:selected').val();
                console.log('Navigate to year: ' + year);
                navigateToYear(year);
            });


            var clearTables = function (nothingtoshow) {
                //Remove existing visible results
                $('#tables').empty();
                if (nothingtoshow) {
                    var htmlString = '<p>' + window.NoRankingSelectedText + '</p>';
                    $('#tables').append(htmlString);
                }

            };

            var removeFilters = function () {
                $('.filter-group-item').removeClass('active');
                $('.filter-group-item').removeClass('disabled');
                $('#selector-text').html('');
                clearTables(true);
            };

            var createSelectorText = function (currentFilters) {
                var rc = '';
                currentFilters.forEach(f => {
                    if (rc !== '') {
                        rc += ' - ';
                    }
                    rc += f.name;
                });
                return rc;
            };

            body.on('click', '.btn-clear-filters', function () {
                removeFilters();
            });

            var updateFilterButtons = function () {
                var activeFilters = $('.filter-group-item.active');
                var curFilters = [];
                $.each(activeFilters, function (index) {
                    var filter = $(activeFilters[index]);


                    var id = filter.attr('filter-id');
                    var name = filter.attr('filter-name');
                    var filteridentifier = filter.parent('.filter-group').attr('filter-identifier');
                    var f = {};
                    f.id = id;
                    f.name = name;
                    f.identifier = filteridentifier;

                    
                    curFilters.push(f);
                    
                });

                console.log(curFilters);

                var selectorText = createSelectorText(curFilters);
                $('#selector-text').html(selectorText);


                var remainingRankings = window.rankings.filter(element => {

                    for (var i = 0; i < curFilters.length; i++) {

                        var filter = curFilters[i];

                        if (filter.identifier === 'class') { continue; } //just ignore this filter

                        if (Number(element[filter.identifier].id) !== Number(filter.id)) {
                            return false;
                        }
                    }
                    return true; //If all filters passed we include the element.
                });

                var classButtons = $('.filter-group[filter-identifier=class]').children('.filter-group-item');

                $.each(classButtons, function (index) {
                    var button = $(classButtons[index]);
                    var id = Number(button.attr('filter-id'));

                    var rankingExists = remainingRankings.find(e => e.class.id === id);

                    if (rankingExists) {
                        button.removeClass('disabled');
                    }
                    else {
                        button.addClass('disabled');
                    }
                });


            };

            body.on('click', '.filter-group-item',
                function () {
                    $(this).parent('.filter-group').children('.filter-group-item').removeClass('active');
                    $(this).addClass('active');

                    var activeButtons = $('.filter-group-item.active');
                    var curFilters = {};
                    $.each(activeButtons, function (index) {
                        var filter = $(activeButtons[index]);
                        var id = filter.attr('filter-id');
                        var filteridentifier = filter.parent('.filter-group').attr('filter-identifier');

                        curFilters[filteridentifier] = id;

                    });

                    //Select active ranking results
                    var elem = window.rankings.filter(element =>
                        element['gender'].id === Number(curFilters['gender']) &&
                        element['ageGroup'].id === Number(curFilters['ageGroup']) &&
                        element['class'].id === Number(curFilters['class']) //&&
                        //element['sport'].id === Number(curFilters['sport'])

                    );

                    //Draw new tables;
                    clearTables();

                    if (elem && elem.length > 0) {
                        elem.forEach(group => {
                            var htmlString = '' +
                                '<div class="table-responsive">' +
                                '<h5>' + group.sport.name + '</h5>' +
                                '<table id="mastermeeting" class="table table-hover table-striped display" width="100%">' +
                                '<thead>' +
                                '<tr>' +
                                ' <th>Rank</th>' +
                                ' <th>Athlete Name</th>' +
                                ' <th>YOB</th>' +
                                '  <th>Time</th>' +
                                '   <th>Wind</th>' +
                                '    <th>Date</th>' +
                                '     <th>Venue</th>' +
                                '      <th>Country</th>' +
                                '   </tr>' +
                                '</thead>' +
                                '<tbody> ';




                            group.rankings.forEach(result => {

                                var resultstring = result.resultFormatted;
                                if (result.conventionString) {
                                    resultstring = '<a href="' + window.eventsUrl + result.masterMeetingId + '/' + result.conventionString + '">' + result.resultFormatted + '</a>';
                                }


                                htmlString += '<tr class="table-row"><td>' +
                                    result.rank +
                                    '</td><td>' +
                                    '<a href="' + window.athleteProfileUrl + '?athleteid=' + result.athleteId + '">' + result.firstName + ' ' + result.lastName + '</a>' +
                                    '</td><td>' +
                                    result.yearOfBirth +
                                    '</td><td>' +
                                    resultstring +
                                    '</td><td>' +
                                    result.wind +
                                    '</td><td>' +
                                    result.date +
                                    '</td><td>' +
                                    result.meetingName +
                                    '</td><td>' +
                                    result.country +
                                    '</tr>';
                            });

                            htmlString += '</tbody ></table ></div>';
                            $('#tables').append(htmlString);

                        });

                    }
                    else {
                        clearTables(true);
                    }

                    updateFilterButtons();


                });
                clearTables(true);

            }

        });
})(window.jQuery);
